<template>
  <div class="isolate">
    <h1>画面切替</h1>
    <ul class="tab-menu-base">
      <li><router-link to="/gourmet/check">投稿内容確認</router-link></li>
      <li><router-link to="/gourmet/alert">お知らせ内容確認登録</router-link></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      id: '',
      pass: ''
    }
  },
  mounted () {
    let isLogin = localStorage.getItem('login')
    if (!isLogin) {
      this.$router.push('/gourmet/check-login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/isolate.vue